import { Platform } from "react-native"

export const isPlatformAndroid = (): boolean => Platform.OS === "android"
